module.exports = __webpack_public_path__ + "img/sink.274c0dc9.jpg";